<template>
    <BreadCrumb PageTitle="Liste réglementaires" />
    <ListeBlacklist />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeBlacklist from "@/components/Blacklist/ListeBlacklist.vue";

export default defineComponent({
    name: "ListeBlacklistPage",
    components: {
        BreadCrumb,
        ListeBlacklist,
    },
});
</script>